import { z } from 'zod';
export const OrgStatusSchema = z.enum(['active', 'suspended']);
export const OrgSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    slug: z.string(),
    status: OrgStatusSchema,
    brandMeta: z.record(z.unknown()),
});
export const CreateOrgRequestSchema = z.object({
    name: z.string().min(1).max(200),
    slug: z.string().min(2).max(80).optional(),
    brandMeta: z.record(z.unknown()).optional(),
    initialAdminEmail: z.string().email().optional(),
});
export const PatchOrgRequestSchema = z.object({
    name: z.string().min(1).max(200).optional(),
    brandMeta: z.record(z.unknown()).optional(),
    status: OrgStatusSchema.optional(),
});
export const InviteOrgAdminRequestSchema = z.object({
    email: z.string().email(),
});
//# sourceMappingURL=orgs.js.map